<template>

    <button class="btn btn-danger" @click="show = true">show modal</button>

    <!-- <Transition name="modal" :duration="100"> -->
    <!-- </Transition> -->
        <div v-if="show" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">default header</slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            default body  {{data}}
                        </slot>
                    </div>

                    <div class="modal-footer d-flex justify-content-between">
                        <slot name="footer">default footer</slot>
                        <button class="btn btn-outline-danger ms-auto" @click="show = false">Yes</button>
                        <button class="btn btn-outline-danger" @click="show = false">No</button>
                    </div>
                </div>
            </div>
        </div>

</template>


<script>
    import { ref, onMounted } from "vue";
    export default {
        name: "LocalModal",
        props:["data"],
        setup() {
            const show = ref();
            onMounted(() => {
                // show.value = true;
            });
            const showModal = () => {
                show.value = true;
            };
            const hideModal = () => {
                show.value = false;
            };
            return { show, showModal, hideModal };
        },
    };
</script>


<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 800px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right1;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter-from {
        opacity: 0;
    }

    .modal-leave-to {
        opacity: 0;
    }

    .modal-enter-from .modal-container,
    .modal-leave-to .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>

